import { useMedia } from '@/hooks/useMedia'
import burger from '@/assets/imgs/burger.svg'
import close from '@/assets/imgs/close.svg'
import logo from '@/assets/imgs/logo-white.png'
import { SIDEBAR_MENU as dict } from '@/resources/dict'

import * as S from './styles'

interface Props {
  opened: boolean
  onClick: (opened: boolean) => void
}

const NavHeader = ({ opened, onClick }: Props) => {
  const isMobile = useMedia(['(max-width: 768px)'], [true], false)

  return (
    <S.Wrapper>
      <S.MenuButton
        aria-label={`${opened ? dict.hideMenu : dict.showMenu}`}
        type="button"
        onClick={() => onClick(!opened)}
      >
        <S.MenuButtonIcon alt={dict.burgerMenu} src={opened ? close : burger} />
      </S.MenuButton>
      {!isMobile && (
        <S.HomeLink to="/poc-orders">
          <img alt={dict.logo} src={logo} height="72px" width="72px" />
        </S.HomeLink>
      )}
    </S.Wrapper>
  )
}

export default NavHeader
